// extracted by mini-css-extract-plugin
module.exports = {"d2xTeaserB":"B_d2xTeaserB__HeblB"};